import defaultProfilePic from '../assets/images/default_profile_pic.jpg';

function ProfilePicInitials() {
  return {
    restrict: 'E',
    scope: {
      initials: '@',
      profilePic: '@',
      showInitials: '='
    },
    replace: true,
    template: `<div class="profile-pic-initials">
    <span class="initials uppercase" ng-show="showInitials === true">
      {{ initials }}
    </span>
    <img ng-hide="showInitials === true" class="img-circle profile-pic" ng-src="{{ profilePic || defaultProfilePic }}">
    </div>`,
    link: (scope) => {
      scope.defaultProfilePic = defaultProfilePic;
    }
  };
}

ProfilePicInitials.$inject = [];

export default ProfilePicInitials;



// WEBPACK FOOTER //
// ./src/directives/profilePicInitials.js